/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import MultiEntityCard from "../../../components/MultiEntities/MultiEntityCard";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import { tooltipClasses, Tooltip, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { multiEntityAllMappings } from "../../../redux/features/multientity/multientity";

import ResponsiveAppBarLogout from "../../../components/ResponsiveAppBar/ResponsiveAppBarLogout/index";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";

import Loader from "../../../components/Loader/Index";
import { useNavigate, useLocation } from "react-router-dom";
import { triggerConfirmBtnClicked } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import IconRoundButton from "../../../components/_utils/CommonButtons/IconRoundButton";
import RectangleSearchBar from "../../../components/_utils/RectangleSearchBar";
import SvgComponent from "../../../components/_utils/SVGComponent";
import ICONS from "../../../assets/Icons";
import CommonCountMultiSelect from "../../../components/_utils/NumberCountComponent/CommonCountMultiSelect";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import PrimaryWithIconButton from "../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
function uniqBy(a, key) {
  return [...new Map(a.map((x) => [key(x), x])).values()];
}

const whiteStar =
  "https://q2pay.in/new_assets/common/detail_page/favourite.svg";
const yellowStar =
  "https://q2pay.in/new_assets/common/detail_page/favourite_filled.svg";
const searchBlue =
  "https://q2pay.in/new_assets/common/view_all/search_white.svg";

const arrowLeftWhite =
  "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg";
const MultiEntityViewAll = ({
  type,
  setIsMultiPopupOpen,
  isMultiPopupOpen,
}) => {
  const entityData = JSON.parse(sessionStorage.getItem("response"));
  const dispatch = useDispatch();
  const searchRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchUserText, setSearchUserText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCards, setSelectedCards] = useState([]);
  const [selectedCardsSub, setSelectedCardsSub] = useState([]);
  const [isMultiCardsSelected, setIsMultiCardsSelected] = useState(false);
  const [pageSizeSelectAll, setPageSizeSelectAll] = useState(false);
  const [isFavourite, setIsFavourite] = useState("");
  const [cardSlideAnimation, setCardSlideAnimation] = useState(false);
  const dropdownOptions = [IntervalConfiguration.intervalTiny];
  const [selectedValue, setSelectedValue] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [allSelectedCards, setAllSelectedCards] = useState({});
  const [, setIsOpen] = useState(false);

  const [pageSize, setPageSize] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );

  const {
    multiEntityAllMappingsData,
    multiEntityAllMappingsLoading,
    multiEntityFavouriteLoading,
  } = useSelector((state) => state.multientity);

  let queryParams = {
    page_no: currentPage,
    page_size: pageSize,
    search_string: searchUserText,
    favourite: isFavourite,
  };

  const handleSelect = (value) => {
    setPageSizeSelectAll(true);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };
  const handlePagination = (page) => {
    setPageSizeSelectAll(true);
    setIsMultiCardsSelected(false);
    setCurrentPage(page);
  };

  const handleCardClick = (card) => {
    if (isSelected(card.id)) {
      setSelectedCards((prev) => prev.filter((item) => item.id !== card.id));
      setAllSelectedCards((prev) => ({
        ...prev,
        [currentPage]:
          prev[currentPage]?.filter((item) => item.id !== card.id) || [],
      }));
    } else {
      setSelectedCards((prev) => [...prev, card]);
      setAllSelectedCards((prev) => ({
        ...prev,
        [currentPage]: [...(prev[currentPage] || []), card],
      }));
    }
  };

  let store = sessionStorage.getItem("previousLog") || "/home";

  const favEntitiesS = sessionStorage.getItem("favourite_entities") ?? "[]";
  const selectedEntitiesS = sessionStorage.getItem("selectedCards");
  const isSelected = (id) => selectedCards.some((card) => card.id === id);

  function handleSet() {
    if (
      location?.state &&
      Array.isArray(location.state) &&
      location.state.length > GlobalConfiguration?.lengthCheckZero
    ) {
      setSelectedCards((prev) => {
        const newCards = location.state.filter(
          (val) => entityData?.employees?.user_id !== val?.sub_user,
        );

        return [...prev, ...newCards];
      });
    } else {
      const favEntities = JSON.parse(selectedEntitiesS ?? favEntitiesS);
      setSelectedCards((prev) => {
        const newCards = favEntities.filter(
          (val) => entityData?.employees?.user_id !== val?.sub_user,
        );

        return [...prev, ...newCards];
      });
      setSelectedCardsSub((prev) => {
        const newCards = favEntities.filter(
          (val) => entityData?.employees?.user_id === val?.sub_user,
        );

        return [...prev, ...newCards];
      });
    }
  }
  const handleToggleSelection = () => {
    const newState = !isMultiCardsSelected;
    setIsMultiCardsSelected(newState);
    if (newState) {
      let store = multiEntityAllMappingsData?.mappings?.filter((val) => {
        return !isSelected(val?.id);
      });
      setSelectedCards((prev) => [...prev, ...store]);
      setAllSelectedCards((prev) => ({
        ...prev,
        [currentPage]: multiEntityAllMappingsData?.mappings,
      }));
    } else {
      const filteredArray = selectedCards.filter(
        (item1) =>
          !multiEntityAllMappingsData?.mappings?.some(
            (item2) => item2.id === item1.id,
          ),
      );
      setSelectedCards(filteredArray);
      setAllSelectedCards((prev) => ({
        ...prev,
        [currentPage]: [],
      }));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    setSearchUserText(e.target.value);
  };

  const normalizedPaginationData = multiEntityAllMappingsData
    ? {
        ...multiEntityAllMappingsData,
        title: {
          ...multiEntityAllMappingsData.title,
          current_page: currentPage,
          page_item_count:
            multiEntityAllMappingsData?.title?.page_item_count ||
            multiEntityAllMappingsData?.mappings?.length ||
            pageSize,
        },
      }
    : multiEntityAllMappingsData;

  useEffect(() => {
    dispatch(multiEntityAllMappings(queryParams));
  }, [searchUserText, pageSize, currentPage, isFavourite]);

  useEffect(() => {
    const handleFavouriteUpdate = (e) => {
      (async () => {
        let response = await dispatch(multiEntityAllMappings(queryParams));

        let favEntities = JSON.parse(
          sessionStorage.getItem("favourite_entities") ?? null,
        );
        let selectedEntities = JSON.parse(
          sessionStorage.getItem("selectedCards") ?? null,
        );

        const theEntityInQuestion = response?.payload?.mappings.filter(
          (x) => x.id === e.detail.id,
        )[0];

        if (e.detail.newFavourite === "Y") {
          favEntities.push(theEntityInQuestion);
        } else {
          favEntities = favEntities.filter((x) => x.id !== e.detail.id);
        }

        selectedEntities = selectedEntities?.map((entity) => {
          if (entity.id === e.detail.id) {
            entity.favourite = e.detail.newFavourite;
          }
          return entity;
        });

        sessionStorage.setItem(
          "favourite_entities",
          JSON.stringify(favEntities),
        );

        const a = JSON.parse(sessionStorage.getItem("response"));
        const current = uniqBy([...favEntities], JSON.stringify).filter(
          (x) => x?.sub_user === a?.employees?.user_id,
        );
        try {
          let sCards = uniqBy(
            [...selectedEntities, ...current, ...selectedCardsSub],
            JSON.stringify,
          );

          setSelectedCards(sCards);

          sessionStorage.setItem("selectedCards", JSON.stringify(sCards));
        } catch {}
      })();
    };
    window.addEventListener("favourite_updated", handleFavouriteUpdate);
    return () => {
      window.removeEventListener("favourite_updated", handleFavouriteUpdate);
    };
  }, [isFavourite]);

  useEffect(() => {
    handleSet();
  }, [isMultiPopupOpen]);

  useEffect(() => {
    if (!multiEntityAllMappingsLoading && multiEntityAllMappingsData) {
      if (
        allSelectedCards[currentPage]?.length ===
        multiEntityAllMappingsData?.mappings?.length
      ) {
        setIsMultiCardsSelected(true);
      } else {
        setIsMultiCardsSelected(false);
      }
    }
  }, [allSelectedCards, multiEntityAllMappingsData]);

  useEffect(() => {
    if (!multiEntityAllMappingsLoading && multiEntityAllMappingsData) {
      let store;

      if (type === "popup") {
        store = JSON.parse(selectedEntitiesS);
      } else {
        store = multiEntityAllMappingsData?.mappings?.filter((val) => {
          return val?.favourite === "Y";
        });
      }

      if (!allSelectedCards.hasOwnProperty(currentPage)) {
        setAllSelectedCards((prev) => ({
          ...prev,
          [currentPage]: store,
        }));
      }
      if (pageSizeSelectAll) {
        let store = multiEntityAllMappingsData?.mappings?.filter((val) => {
          return isSelected(val?.id);
        });
        setAllSelectedCards((prev) => ({
          ...prev,
          [currentPage]: store,
        }));
        setPageSizeSelectAll(false);
      }
    }
  }, [multiEntityAllMappingsData]);

  useEffect(() => {
    const handleDropDown = (e) => {
      if (searchRef.current && searchRef.current.contains(e.target)) {
      } else {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handleDropDown);
  }, [searchRef]);

  useEffect(() => {
    if (multiEntityAllMappingsData) {
      const total =
        multiEntityAllMappingsData.total_count ??
        GlobalConfiguration.lengthCheckZero;
      const maxPage =
        multiEntityAllMappingsData.title?.total_pages ??
        GlobalConfiguration.lengthCheckOne;

      if (
        total === GlobalConfiguration.lengthCheckZero &&
        currentPage !== GlobalConfiguration.lengthCheckOne
      ) {
        setCurrentPage(1);
      }
      // Optional: also clamp if somehow page is too high
      else if (
        currentPage > maxPage &&
        maxPage >= GlobalConfiguration.lengthCheckOne
      ) {
        setCurrentPage(maxPage);
      }
    }
  }, [multiEntityAllMappingsData, currentPage]);

  return (
    <>
      <div
        className={` bg-primary-bg relative flex flex-col overflow-x-hidden ${type !== "popup" ? " min-h-screen" : ""}`}
        style={{
          overflowY: type === "popup" ? "auto" : "",
          height: type === "popup" ? "var(--popup-height)" : "",
        }}
      >
        <div className="mulEntity_logout_navbar ">
          {type !== "popup" && <ResponsiveAppBarLogout />}
        </div>

        <div
          className={`fixed top-top-base left-left-base w-full bg-primary-nav z-z-index-max h-[calc(var(--fixed-header)+var(--navbar-height))] ${type !== "popup" ? "filterAllEntitiesAnimate" : ""}`}
        >
          {/* Inner div  */}
          <div
            className="hidden Qlg:block w-full"
            style={{
              backgroundColor: "var(--primary-nav)",
              position: "absolute",
              left: "var(--left-base)",
              top:
                type === "popup"
                  ? "var(--timeline-top)"
                  : "var(--navbar-height)",
            }}
          >
            <div
              className={`bg-primary-nav px-padding-md flex  flex-col z-z-index-max transition-[height] duration-0.2s items-center ease-in-out relative  ${
                showSearchBar
                  ? "h-[var(--navbar-breadcrumb-height)] "
                  : "h-[var(--fixed-header]"
              }`}
            >
              <div className="multiEntityViewAllCards max-w-max-content-width h-fixed-header w-full flex  items-center">
                <div className="flex items-center h-full flex-col bg-primary-nav-act mr-margin-md py-padding-button-m px-padding-lg gap-gap-xs">
                  <CommonCountMultiSelect
                    count={selectedCards?.length}
                    bgColor={"bg-primary-nav"}
                    textColor={"text-text-primary"}
                  />
                  <span className="text-text-primary text-font-xxs font-normal">
                    Selected
                  </span>
                </div>

                <div className="w-width-full mr-margin-md">
                  <p className="text-text-primary text-font-sm font-normal">
                    The selected entities below are currently available in the
                    Quick Swap tab. You may add or remove entities, and updates
                    will be reflected accordingly. Currently logged in is
                    selected by default.
                  </p>
                </div>

                <div className="flex items-center gap-gap-sm justify-end mr-margin-md">
                  <IconRoundButton
                    btnType="button"
                    enabledBgColor="var(--primary-bg)"
                    handleFunction={() => {
                      setCurrentPage(1);
                      setIsFavourite(isFavourite === "Y" ? "" : "Y");
                      setPageSizeSelectAll(true);
                    }}
                    hoverOption="white"
                    icon={isFavourite === "Y" ? yellowStar : whiteStar}
                    title="Favourites"
                    isDisabled={multiEntityFavouriteLoading}
                  />
                </div>
                <PrimaryButton
                  btnText="Confirm"
                  handleFunction={() => {
                    setCardSlideAnimation(true);
                    const favEntitiesS =
                      sessionStorage.getItem("favourite_entities") ?? "[]";
                    const a = JSON.parse(sessionStorage.getItem("response"));
                    const current = uniqBy(
                      [...JSON.parse(favEntitiesS)],
                      JSON.stringify,
                    ).filter((x) => x?.sub_user === a?.employees?.user_id);
                    sessionStorage.setItem(
                      "selectedCards",
                      JSON.stringify(
                        uniqBy([...selectedCards, ...current], JSON.stringify),
                      ),
                    );
                    if (type === "popup") {
                      setIsMultiPopupOpen(false);
                    } else {
                      setTimeout(() => {
                        navigate(store, {
                          replace: true,
                          state: location.state?.length < selectedCards?.length,
                        });
                        sessionStorage.removeItem("previousLog");

                        sessionStorage.setItem("conciergeLogin", true);
                      }, 400);
                    }
                    dispatch(triggerConfirmBtnClicked());
                  }}
                  enabledTextColor={"var(--text-primary)"}
                  enabledBgColor="var(--positive-act)"
                  hoverOption="black"
                  isDisabled={multiEntityFavouriteLoading}
                />
              </div>

              <div className="w-[var(--Tab-max)] mx-auto">
                {showSearchBar && (
                  <RectangleSearchBar
                    handleSearch={setSearchUserText}
                    showSearchBar={showSearchBar}
                    searchUserText={searchUserText}
                    setSearchUserText={setSearchUserText}
                    onPaste={handlePaste}
                    toggleShowSearchBar={() => {
                      setShowSearchBar(!showSearchBar);
                    }}
                    bgColor={"bg-[var(--primary-bg)]"}
                    bgHover={"hover:bg-custom-cardHover"}
                    setCurrentPage={setCurrentPage}
                    searchRef={searchRef}
                    placeholder="Search by entity name/ PAN number"
                  />
                )}
              </div>
            </div>
          </div>

          {/* Inner div  */}
        </div>

        <div className="flex flex-col Qlg:hidden bg-primary-nav w-full mobile_h_multi fixed top-top-base left-left-base z-z-index-max">
          <div className="flex h-mobile-create-header items-center justify-between border-b border-primary-bg">
            <div className="flex items-center px-padding-md">
              <div
                className="pr-padding-md cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <SvgComponent
                  color="var(--text-primary)"
                  height={"var(--icon-sm)"}
                  width="var(--icon-sm)"
                  url={arrowLeftWhite}
                />
              </div>
              <TitleSubtitlePair
                title={selectedCards?.length}
                subtitle="Entities selected"
                variant="md"
              />
            </div>

            <div className="flex items-center px-padding-md">
              <IconRoundButton
                btnType="button"
                enabledBgColor="var(--primary-bg)"
                handleFunction={() => {
                  setCurrentPage(1);
                  setIsFavourite(isFavourite === "Y" ? "" : "Y");
                  setPageSizeSelectAll(true);
                }}
                hoverOption="white"
                icon={isFavourite === "Y" ? yellowStar : whiteStar}
                title="Favourites"
                isDisabled={multiEntityFavouriteLoading}
              />
              <Tooltip
                componentsProps={{
                  popper: {
                    sx: {
                      [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: (theme) => theme.palette.common.black,
                      },
                      zIndex: "var(--max-zindex) !important",
                    },
                  },
                }}
                title="Search"
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSearchBar(!showSearchBar);
                  }}
                  style={{
                    pointerEvents: "none",
                    opacity: "var(--light-opacity)",
                  }}
                  className="h-full hidden py-padding-md px-padding-md"
                >
                  <img
                    className="h-icon-sm w-icon-sm"
                    src={searchBlue}
                    alt="search-image"
                  />
                </Box>
              </Tooltip>
            </div>
          </div>
          <div className="p-padding-md flex flex-col gap-gap-sm w-full border-t border-primary-bg">
            <h4 className="text-text-primary font-semibold text-font-sm">
              Multiple Entities Found
            </h4>
            <p className="text-text-primary text-font-xs font-normal">
              The selected entities below are currently available in the Quick
              Swap tab. You may add or remove entities, and updates will be
              reflected accordingly. Currently logged in is selected by default.
            </p>
          </div>
        </div>

        {type === "popup" && (
          <div className="hidden Qlg:flex items-center justify-between p-padding-md fixed w-full bg-primary-bg top-top-base z-z-index-max">
            <div className="flex flex-col gap-gap-xs">
              <h3 className="text-text-primary font-semibold tracking-[letterSpacing] text-font-md">
                Multiple entities linked
              </h3>
              <p className="text-text-secondary font-normal text-font-xs">
                Select which ones to include in the quick swap tab.
              </p>
            </div>
            <IconRoundButton
              enabledBgColor={"var(--primary-nav)"}
              isLoading={false}
              icon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
              hoverOption={"white"}
              title={"Close"}
              handleFunction={() => {
                setIsMultiPopupOpen(false);

                dispatch(triggerConfirmBtnClicked());
              }}
              btnType={"button"}
            />
          </div>
        )}

        <div
          className={`w-full px-padding-button-l ${
            type !== "popup"
              ? "lg:mt-[calc(var(--fixed-header)+var(--navbar-height))]"
              : ""
          }`}
        >
          <div
            className={`flex flex-col gap-gap-sm mobile_header_section_margin w-full  mx-auto Qlg:w-std-width
            ${
              type === "popup"
                ? "mt-[var(--fixed-mobile-header)] Qlg:mt-[var(--fixed-mobile-header)]"
                : "mt-[var(--fixed-mobile-header)] Qlg:mt-margin-base"
            }`}
          >
            <h3
              className={` text-text-primary font-semibold ${type !== "popup" ? "pt-padding-md" : "Qlg:py-padding-base py-padding-md"}`}
            >
              Currently logged in entity
            </h3>
            <MultiEntityCard
              currentEntityName={entityData?.entity?.entity_name}
              currentEntityPan={entityData?.entity?.entity_pan}
              isActive={true}
              type={"multiEntityViewAllCard"}
              isSelected={isSelected}
              cardSlideAnimation={cardSlideAnimation}
            />
          </div>
        </div>

        <div
          className={` ${!multiEntityAllMappingsData?.mappings?.length ? "pb-padding-lg" : "pb-padding-lg"}  flex-1`}
          style={{
            display: !multiEntityAllMappingsData?.mappings?.length && "flex",
            justifyContent:
              !multiEntityAllMappingsData?.mappings?.length && "center",
            alignItems:
              !multiEntityAllMappingsData?.mappings?.length && "center",
            flexDirection: "column",
          }}
        >
          {!multiEntityAllMappingsData?.mappings?.length ? (
            <div
              className="flex flex-col justify-center items-center text-center gap-gap-md my-margin-md flex-grow"
              style={{
                flex: GlobalConfiguration.lengthCheckOne, // allow to take remaining space
              }}
            >
              <img
                src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                alt="Settings"
                className="h-[var(--country-dropdown-width)] w-totp-qr-box-width "
              />
              <p className="ifsc-enter-label text-font-sm font-normal font-sans">
                No data found.
              </p>
              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText="Clear parameters"
                enabledTextColor="var(--text-primary)"
                handleFunction={() => setIsFavourite("")}
                buttonRef={null}
                hoverOption="white"
              />
            </div>
          ) : (
            <>
              <div
                className={`sticky flex justify-center px-padding-md bg-primary-bg z-z-index-max py-padding-md ${type === "popup" ? "top-[var(--multientity-header-height)] Qsmd:top-[var(--fixed-mobile-header)] Qlg:top-[var(--multi-sticky-top)]" : "top-[var(--multientity-header-height)] Qlg:top-[calc(var(--fixed-header)+var(--navbar-height))]"}`}
              >
                <div className="Qlg:w-max-content-width w-full flex items-center justify-between ">
                  <p className="text-text-primary font-semibold text-font-md">
                    Select entities for ‘Quick Swap’
                  </p>
                  <PrimaryWithIconButton
                    btnText="Select all"
                    btnType="button"
                    handleFunction={() => {
                      handleToggleSelection();
                    }}
                    isDisabled={multiEntityFavouriteLoading}
                    enabledTextColor={"var(--text-primary)"}
                    disabledTextColor={"var(--text-secondary)"}
                    enabledBgColor={
                      isMultiCardsSelected && !multiEntityAllMappingsLoading
                        ? "var(--positive-bg)"
                        : "var(--primary-nav)"
                    }
                    disabledBgColor={"var(--primary-nav)"}
                    isLoading={false}
                    icon={
                      isMultiCardsSelected && !multiEntityAllMappingsLoading
                        ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS.SELECTED_WITH_WHITE_FILLED
                    }
                    hoverOption={
                      isMultiCardsSelected && !multiEntityAllMappingsLoading
                        ? "black"
                        : "white"
                    }
                    iconToBeAlign="right"
                  />
                </div>
              </div>
              <div className="pb-padding-button-l">
                <div
                  className={`flex pb-padding-md gap-gap-md flex-wrap  w-[var(--tab-width-normal)] mx-auto multiEntityCardcontainer ${
                    multiEntityAllMappingsLoading === true ? "h-full" : "h-auto"
                  }`}
                  style={{
                    justifyContent:
                      multiEntityAllMappingsLoading === true
                        ? "center"
                        : "space-between",
                    alignItems:
                      multiEntityAllMappingsLoading === true
                        ? "center"
                        : "flex-start",
                  }}
                >
                  {multiEntityAllMappingsLoading === false ? (
                    <>
                      {multiEntityAllMappingsData?.mappings
                        ?.filter((val) => {
                          return (
                            entityData?.employees?.user_id !== val?.sub_user
                          );
                        })
                        .map((val) => {
                          return (
                            <MultiEntityCard
                              currentEntityName={
                                entityData?.entity?.entity_name
                              }
                              currentEntityPan={entityData?.entity?.entity_pan}
                              type={"multiEntityViewAllCard"}
                              selectedIds={selectedCards}
                              setSelectedIds={setSelectedCards}
                              handleCardClick={handleCardClick}
                              isSelected={isSelected}
                              card={val}
                              cardSlideAnimation={cardSlideAnimation}
                            />
                          );
                        })}
                    </>
                  ) : (
                    <Loader type={"multiEntity"} />
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        <div
          className={`w-full  fixed bottom-bottom-base left-left-base bg-primary-nav shadow-box-shadow-top transition-[all] duration-[var(--animation-fast)] ease-linear ${
            type !== "popup" && "paginationComponentAnimate"
          }`}
        >
          <div className="Qlg:hidden block p-padding-md">
            <PrimaryButton
              // className=" !text-text-primary !bg-Button-green  !hover:bg-Button-green-hover !px-[var(--padding-lg)] !py-[var(--padding-md)] !h-full !w-full !rounded-none !font-semibold !text-font-md !tracking-letter-space !capitalize"
              handleFunction={() => {
                setCardSlideAnimation(true);
                const favEntitiesS =
                  sessionStorage.getItem("favourite_entities") ?? "[]";
                const a = JSON.parse(sessionStorage.getItem("response"));
                const current = uniqBy(
                  [...JSON.parse(favEntitiesS)],
                  JSON.stringify,
                ).filter((x) => x?.sub_user === a?.employees?.user_id);
                sessionStorage.setItem(
                  "selectedCards",
                  JSON.stringify(
                    uniqBy([...selectedCards, ...current], JSON.stringify),
                  ),
                );
                if (type === "popup") {
                  setIsMultiPopupOpen(false);
                } else {
                  setTimeout(() => {
                    navigate(store, {
                      replace: true,
                      state: location.state?.length < selectedCards?.length,
                    });
                    sessionStorage.removeItem("previousLog");

                    sessionStorage.setItem("conciergeLogin", true);
                  }, IntervalConfiguration.intervalSmaller);
                }
                dispatch(triggerConfirmBtnClicked());
              }}
              btnText="Confirm"
              btnType="button"
              enabledTextColor={"var(--text-primary)"}
              enabledBgColor="var(--positive-act)"
              hoverOption="white"
              isDisabled={multiEntityFavouriteLoading}
              fullWidthRequired
            />
          </div>
          {multiEntityAllMappingsData?.mappings?.length ===
          GlobalConfiguration.lengthCheckZero ? null : (
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={normalizedPaginationData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              type={"multi_Entity"}
              setIsOpen={setIsOpen}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MultiEntityViewAll;
